/**
 * @fileoverview
 * Reducer para gerenciar o estado das extensões customizadas carregadas.
 */

const LOAD_CUSTOM_EXTENSION = 'scratch-gui/custom-extensions/LOAD_CUSTOM_EXTENSION';
const UNLOAD_CUSTOM_EXTENSION = 'scratch-gui/custom-extensions/UNLOAD_CUSTOM_EXTENSION';
const CLEAR_CUSTOM_EXTENSIONS = 'scratch-gui/custom-extensions/CLEAR_CUSTOM_EXTENSIONS';

const initialState = {
    loadedExtensions: []
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case LOAD_CUSTOM_EXTENSION:
        if (state.loadedExtensions.includes(action.extensionId)) {
            return state;
        }
        return {
            ...state,
            loadedExtensions: [...state.loadedExtensions, action.extensionId]
        };
    case UNLOAD_CUSTOM_EXTENSION:
        return {
            ...state,
            loadedExtensions: state.loadedExtensions.filter(id => id !== action.extensionId)
        };
    case CLEAR_CUSTOM_EXTENSIONS:
        return {
            ...state,
            loadedExtensions: []
        };
    default:
        return state;
    }
};

const loadCustomExtension = function (extensionId) {
    return {
        type: LOAD_CUSTOM_EXTENSION,
        extensionId: extensionId
    };
};

const unloadCustomExtension = function (extensionId) {
    return {
        type: UNLOAD_CUSTOM_EXTENSION,
        extensionId: extensionId
    };
};

const clearCustomExtensions = function () {
    return {
        type: CLEAR_CUSTOM_EXTENSIONS
    };
};

export {
    reducer as default,
    initialState,
    loadCustomExtension,
    unloadCustomExtension,
    clearCustomExtensions
};
